/* eslint-disable no-confusing-arrow */
import React from 'react';
import Image from 'next/legacy/image';
import { productTagsClass } from '@components/STP/ProductDetails/ProductTagFactoryWithSTP';
import HotelApi, { HotelApiProduct } from '@customTypes/hotel-api';
import useHotSpot from '@hooks/useHotSpot';
import { HotSpotMin } from '@customTypes/hot-spot';
import AVAILABILITY from '@constants/product';
import showClosedForSeasonBanner from '@helpers/showClosedForSeasonBanner';
import TagIcon from '@assets/images/tag.svg';
import { hotelOffersTags } from '@constants/hotelOffers';
import Badge from './Badge';

type Props = {
  product: HotelApiProduct;
  hotel: HotelApi;
  date: Date | undefined;
  isProductUnavailable: boolean;
  isPricingExperimentEnabled: boolean;
  classes?: string;
  hasProductOffer?: boolean;
};

export default function BadgeSRP({
  classes = '',
  product,
  hotel,
  date,
  isProductUnavailable,
  isPricingExperimentEnabled,
  hasProductOffer = false,
}: Props) {
  const getProductAvailabilityText = (currentProduct: HotelApiProduct) =>
    currentProduct.availability === AVAILABILITY.UNAVAILABLE
      ? AVAILABILITY.SOLD_OUT
      : AVAILABILITY.AVAILABLE;

  const { getDiscountText } = useHotSpot();
  let tagContent = '';
  let tagClass = '';
  let icon = null;
  const showAvailabilityWarning = product.quantity && product.quantity > 0 && product.quantity < 5;

  // Hot Spot
  if (
    product.is_hot_spot &&
    hotel.hotSpot &&
    hotel.hotSpot.is_current_hot_spot_hotel &&
    !isProductUnavailable
  ) {
    tagContent = `Save ${getDiscountText(hotel.hotSpot as HotSpotMin)}`;
    tagClass = productTagsClass.HOT_SPOT;
  } else if (hasProductOffer && !isProductUnavailable) {
    tagContent =
      hotelOffersTags[product.product_offer!]?.shortTitle.replace(
        '[[AMOUNT]]',
        product.product_offer_amount || '',
      ) || '';
    tagClass = productTagsClass.HOTEL_OFFER;
    icon = <Image src={TagIcon} alt="tag-icon" />;
    // Pricing Markdown
  } else if (
    product.is_strikethrough_pricing &&
    product.max_price &&
    product.max_price > product.price &&
    !isProductUnavailable &&
    isPricingExperimentEnabled
  ) {
    tagContent = 'Weekday Rate';
    tagClass = productTagsClass.PRICING_MARKDOWN;
    // Closed
  } else if (isProductUnavailable) {
    tagContent =
      hotel.closedForSeason && showClosedForSeasonBanner(hotel.reopenDate, date)
        ? 'Unavailable'
        : getProductAvailabilityText(product);
    tagClass = productTagsClass.UNAVAILABLE;
    // Availability warning
  } else if (!isProductUnavailable && showAvailabilityWarning && date) {
    tagContent = `Only ${product.quantity} Left`;
    tagClass = productTagsClass.UNITS_LEFT;
  } else {
    tagClass = '';
  }

  return (
    <Badge
      tagContent={tagContent}
      tagClass={`${tagClass} ${classes}`}
      icon={icon}
      upperCase={false}
    />
  );
}
